export default {
  miniSidebarAction(context, payload) {
    return new Promise((resolve, reject) => {
      if (context.state.miniSidebarMenu) {
        context.commit("miniSidebarCommit", false);
        resolve(false);
      } else {
        context.commit("miniSidebarCommit", true);
        resolve(true);
      }
    });
  },
  activePageAction(context, payload) {
    context.commit("activePageCommit", payload);
  },
  setLangAction(context, payload) {
    context.commit("setLangCommit", payload);
  },
  setTimeZoneAction(context, payload) {
    context.commit("setTimeZoneCommit", payload);
  },
  setUserAction(context, payload) {
    context.commit("setUserCommit", payload);
  },
  setOrganizationAction(context, payload) {
    context.commit("setOrganizationCommit", payload);
  },
  setRtlAction(context, payload) {
    document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    let body = document.getElementsByTagName("body");
    body[0].classList.add("rtl");
    body[0].classList.remove("light");
  },
  removeRtlAction(context, payload) {
    document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
    let body = document.getElementsByTagName("body");
    body[0].classList.remove("rtl");
    body[0].classList.add("light");
  },
};
